var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode"},[_vm._m(0),_c('div',{staticClass:"barcode__bottom"},[_c('div',{staticClass:"barcode__bottom--button",on:{"click":_vm.closeBarcodeComponent}},[_vm._v(" 取消扫描 ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode__loading",attrs:{"id":"barcodeLoading"}},[_c('i',{staticClass:"el-icon-loading"})])
}]

export { render, staticRenderFns }